/**
 * 导入工具类
 */
import { isInApp, isIOS, isAndroid } from '../utils/index';

/**
 * 导入handler
 */
import { bridgeCallHandler } from './bridge';

/**
 * 关闭webview方法
 */
export function closeWebView(): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端关闭webview');
    window.close();
    return;
  }

  bridgeCallHandler('closeWebView', 'back', null);
}

/**
 * 打开股票详情
 * @param data
 */
export function openStockDetail(data: StockOptions): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端打开股票详情');
    return;
  }
  let params: string = JSON.stringify(data);
  bridgeCallHandler('openStockDetail', params, null);
}

/**
 * 调用客户端打开股票详情页，带范围
 * @param data
 * @returns
 */
export function openStockDetailsWithRange(data: StockRangeOptions): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端打开股票详情页，带范围');
    return;
  }

  let params: string = JSON.stringify(data);
  bridgeCallHandler('openStockDetailsWithRange', params, null);
}

/**
 * 获取自选股
 * @param callback
 */
export function getSelfStocks(callback: BridgeResponseCallback): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端获取自选股');
    callback('');
    return;
  }

  bridgeCallHandler('getSelfStocks', '', callback);
}

/**
 * 获取资讯菜单列表
 */
export function getNewsTabList(callback: BridgeResponseCallback): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端获取资讯菜单列表');
    callback('');
    return;
  }

  bridgeCallHandler('getNewsTabList', '', callback);
}

/**
 * 获取用户信息
 * @param callback
 * @returns
 */
export function getUserInfo(callback: BridgeResponseCallback): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端获取用户信息');
    callback('');
    return;
  }

  bridgeCallHandler('getUserInfo', '', callback);
}

/**
 * 打开微信
 */
export function openWeChat(): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端打开微信');
    return;
  }

  bridgeCallHandler('openWeChat', '', null);
}

/**
 * 获取设备唯一标识
 * @param callback
 * @returns
 */
export function getLocalUuid(callback: BridgeResponseCallback): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端获取设备唯一标识');
    return;
  }

  bridgeCallHandler('getLocalUuid', '', callback);
}

/**
 * 获取当前设备模式
 * @param callback
 * @returns
 */
export function getSystemTheme(callback: BridgeResponseCallback): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端获取当前设备模式');
    return;
  }

  bridgeCallHandler('getSystemTheme', '', callback);
}

/**
 * 打开pdf
 * @param url
 */
export function openPdf(url: string): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端获打开pdf');
    return;
  }

  bridgeCallHandler('openPdf', url, null);
}

/**
 * 获取app版本号
 * @param callback
 * @returns
 */
export function getAppVersion(callback: BridgeResponseCallback): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端获取当前版本号');
    callback('');
    return;
  }

  bridgeCallHandler('getAppVersion', '', callback);
}

/**
 * 拨打电话
 * @param phone
 */
export function callPhone(phone: string): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端拨打电话');
    return;
  }

  bridgeCallHandler('callPhone', phone, null);
}

/**
 * 打开原生toast弹框
 * @param message
 */
export function nativeToast(message: string): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端toast弹框');
    return;
  }
  let data: {
    msg: string;
  } = {
    msg: message,
  };
  let params: string = JSON.stringify(data);
  bridgeCallHandler('nativeToast', params, null);
}

/**
 * 打开创客直播
 * @param data
 * @returns
 */
export function openLiveUrl(data: OpenCkLiveOptions): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端打开创客直播');
    return;
  }

  let params: string = JSON.stringify(data);
  bridgeCallHandler('openLiveUrl', params, null);
}

/**
 * 打开新的webview
 * @param data
 * @returns
 */
export function openWebviewUrl(data: OpenNewWebViewOptions): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端打开新的webview');
    return;
  }

  let params: string = JSON.stringify(data);
  bridgeCallHandler('openWebUrl', params, null);
}

/**
 * 打开分享弹框
 * @param data
 */
export function openCourseShareDialog(data: CourseShareOptions): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端打开分享弹框');
    return;
  }

  let params: string = JSON.stringify(data);
  bridgeCallHandler('openShareDialog', params, null);
}

/**
 * 获取状态栏高度
 * @param callback
 * @returns
 */
export function getStatusBarHeight(callback: BridgeResponseCallback): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端获取状态栏高度');
    callback(0);
    return;
  }

  if (isIOS()) {
    bridgeCallHandler('getStatusBarHeight', '', (val: BridgeResponse) => {
      if (!val) {
        callback(0);
        return;
      }

      let height: number = Math.floor(Number(val));
      callback(height);
    });
  }
  if (isAndroid()) {
    let element: HTMLDivElement = document.createElement('div');
    element.style.height = '1rem';
    document.body.appendChild(element);
    let statusBarHeight: number = element.getBoundingClientRect().height;
    document.body.removeChild(element);
    callback(statusBarHeight);
  }
}

/**
 * 获取原生主题
 * @returns
 */
export function getNativeTheme(callback: BridgeResponseCallback): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端获取原生主题');
    return;
  }

  bridgeCallHandler('getNativeTheme', '', callback);
}

/**
 * 调用客户端打开相册选择图片
 * @param callback
 */
export function chooseImage(callback: BridgeResponseCallback): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端打开相册选择图片');
    return;
  }
  bridgeCallHandler('chooseImage', '', callback);
}

/**
 * 调用客户端注销登录后退出登录
 */
export function exitApp(): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端注销登录后退出登录');
    return;
  }
  bridgeCallHandler('exitApp', '', null);
}

/**
 * 调用客户端打开资金页面
 * @param data
 * @returns
 */
export function openFiancePage(data: OpenFinanceOptions): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端打开资金页面');
    return;
  }

  let params: string = JSON.stringify(data);
  bridgeCallHandler('openFiancePage', params, null);
}

/**
 * 打开自选股页面
 * @param groupId
 */
export function openOptionalStockPage(groupId: string) {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端打开自选股页面');
    return;
  }

  bridgeCallHandler('openOptionalStockPage', groupId, null);
}

/**
 * 调用客户端打开选股页面
 */
export function openSelectStock(): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端打开选股页面');
    return;
  }

  bridgeCallHandler('openSelectStock', '', null);
}

/**
 * 关闭客户回访问弹框
 */
export function answerDialogDismiss(): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端关闭客户回访问弹框');
    return;
  }

  bridgeCallHandler('answerDialogDismiss', '', null);
}

/**
 * 退出登录
 */
export function logOut(): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端退出登录');
    return;
  }

  bridgeCallHandler('logOut', '', null);
}

/**
 * 触发更新页面
 * @param data
 */
export function callUpdateEvent<T = any>(eventName: string, data: T): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端触发更新页面');
    return;
  }

  let setData: BridgeUpdateOptions<T> = {
    type: 'get',
    key: eventName,
    data: data,
  };
  let params = JSON.stringify(setData);
  bridgeCallHandler('toRefreshPage', params, null);
}

/**
 * 禁止左滑关闭事件
 * @param flag
 * @returns
 */
export function disableLeftSwipeClose(flag: boolean = true): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端禁止左滑关闭事件');
    return;
  }
  let val: string = flag ? 'disabled' : 'enabled';
  bridgeCallHandler('disableLeftSwipeClose', val, null);
}

/**
 * 调用客户端打开拍照
 * @param callback
 * @returns
 */
export function openCamera(callback: BridgeResponseCallback): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端打开拍照');
    return;
  }

  bridgeCallHandler('openCamera', '', callback);
}

/**
 * 调用客户端打开录音权限
 * @returns
 */
export function requestRecordPermission(callback: (data: string) => void): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端打开录音权限');
    return;
  }

  bridgeCallHandler('requestRecordPermission', '', callback);
}

/**
 * 调用客户端批量选择图片
 * @param callback
 * @returns
 */
export function chooseImageMulti(count: number, callback: BridgeResponseCallback): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端打开录音权限');
    return;
  }

  bridgeCallHandler('chooseImageMulti', String(count), callback);
}

/**
 * 禁止息屏
 * @param flag
 */
export function setScreenOnStatus(flag: boolean): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端禁止禁止息屏');
    return;
  }
  let val: string = flag ? 'Y' : 'N';
  bridgeCallHandler('setScreenOnStatus', val, null);
}

/**
 * 打开外部链接
 * @param url
 * @returns
 */
export function openExternalLink(url: string): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端打开外链');
    return;
  }
  bridgeCallHandler('openExternalLink', url, null);
}

/**
 * 调用客户端分享
 * @param data
 * @returns
 */
export function openShareDialog(data: ShareOptions): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端分享');
    return;
  }

  let params: string = JSON.stringify(data);
  bridgeCallHandler('showShareDialog', params, null);
}

/**
 * 调用客户端打开课程弹框
 * @param data
 */
export function openShowCourseDialog(url: string): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端打开课程弹框');
    return;
  }
  bridgeCallHandler('showCourseDialog', url, null);
}


/**
 * 获取IOS系统版本号
 * @param callback 
 * @returns 
 */
export function iosSystemVersion(callback: BridgeResponseCallback): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用IOS获取系统版本号');
    return;
  }

  bridgeCallHandler('iosSystemVersion', '', callback);
}
